import React from "react";
import { cls } from "cls";
import NotificationCenter from "~/common/Notification/NotificationCenter";
import GroupSection from "./GroupSection";
import { PageCreatorModel } from "./Models/PageCreatorPage";

const PageCreatorPage = ({
  groups,
  activeStartDate,
  activeEndDate,
  couponCode,
}: PageCreatorModel) => {
  const headerGroup = groups.find(
    (group) => group.name.toLowerCase() === "header",
  );

  return (
    <div
      className={cls("bg-white", "flex", "flex-col", "w-full")}
      data-module="initPageCreatorPage"
    >
      {headerGroup &&
        headerGroup.sections.length > 0 &&
        headerGroup.sections.map((section) => (
          <div id="header-group-wrapper" key={section.sortOrder}>
            <GroupSection
              section={section}
              couponCode={couponCode}
              activeStartDate={activeStartDate}
              activeEndDate={activeEndDate}
              isItemListingPage={false}
              key={section.sortOrder}
              isHeaderGroup
            />
          </div>
        ))}
      {groups
        .filter((group) => group.name.toLowerCase() !== "header")
        .map((group) => (
          <div
            className={cls("w-full")}
            id={group.name}
            key={group.name + group.sortOrder}
          >
            <div className={cls("container")}>
              <h2
                className={cls(
                  "block",
                  "font-bold",
                  "text-3xl",
                  "mb-0",
                  "mt-10",
                  "text-gray-900",
                  "capitalize",
                )}
              >
                {group.name}
              </h2>
              {group.sections.length > 0 && (
                <div
                  className={cls(
                    "mx-auto",
                    "mt-6",
                    "mb-12",
                    "space-y-4",
                    "w-full",
                    "sm:space-y-6",
                  )}
                >
                  {group.sections.map((section) => (
                    <GroupSection
                      section={section}
                      couponCode={couponCode}
                      activeStartDate={activeStartDate}
                      activeEndDate={activeEndDate}
                      key={section.sortOrder}
                      isItemListingPage={false}
                      isHeaderGroup={false}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      <NotificationCenter />
    </div>
  );
};

export default PageCreatorPage;
